<a translate routerLink="/counties" routerLinkActive="active">app.counties</a>

@if (user.$isAdmin) {
  <a translate routerLink="/users" routerLinkActive="active"
    >app.users</a
    >
  }

  <a translate id="pdfDownloads" routerLink="/downloads" routerLinkActive="active"
    >app.pdf_downloads</a
    >

    @if (user.$isViewOnly && !user.$isCourthouseUser) {
      <a
        translate
        id="invoices"
        routerLink="/invoices"
        routerLinkActive="active"
        >app.invoices</a
        >
      }
